import { useEffect, useState } from 'react';

/**
 * Два состояния нужны для создания плавной анимации стрелочки при клике на закрытую подкатегорию.
 */

export const useExpandedState = (initialIsOpen: boolean) => {
  // Инициализируем состояние стрелки как false для корректной начальной анимации
  const [isArrowExpanded, setIsArrowExpanded] = useState(false);
  // Состояния открытой категории анимации не требует
  const [isCategoryExpanded, setIsCategoryExpanded] = useState(false);

  // Синхронизируем состояние стрелки с initialIsOpen
  useEffect(() => {
    setIsArrowExpanded(initialIsOpen);
    setIsCategoryExpanded(initialIsOpen);
  }, [initialIsOpen]);

  const toggleExpandedState = () => {
    setIsArrowExpanded(!isArrowExpanded);
    setIsCategoryExpanded(!isArrowExpanded);
  };

  return {
    isArrowExpanded,
    isCategoryExpanded,
    toggleExpandedState,
  };
};
